import { useRef, useState } from "react";
import { ImagePlus, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

export const ImageUpload = ({ value, onChange, testid = "image-upload", label = "Photo" }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      toast.error("Image must be under 5 MB");
      return;
    }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      onChange(data?.url ?? "");
      toast.success("Photo uploaded");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid={testid}>
      <span className="text-xs uppercase tracking-wider text-slate-400">{label}</span>
      <div className="mt-2 flex items-center gap-4">
        <div className="relative flex h-20 w-20 shrink-0 items-center justify-center overflow-hidden rounded-xl border border-white/10 bg-ink">
          {value ? <img src={value} alt="" className="h-full w-full object-cover" data-testid={`${testid}-preview`} /> : <ImagePlus size={22} className="text-slate-500" />}
          {value && (
            <button type="button" onClick={() => onChange("")} className="absolute right-1 top-1 rounded-full bg-ink/80 p-0.5 text-slate-200 hover:text-white" aria-label="Remove photo" data-testid={`${testid}-remove`}>
              <X size={12} />
            </button>
          )}
        </div>
        <div>
          <button type="button" disabled={busy} onClick={() => input.current?.click()} className="btn-ghost px-4 py-2 text-xs" data-testid={`${testid}-btn`}>
            {busy ? <Loader2 size={14} className="animate-spin" /> : <ImagePlus size={14} />} {value ? "Change photo" : "Upload photo"}
          </button>
          <p className="mt-1.5 text-[11px] text-slate-400">JPG, PNG or WEBP · max 5 MB</p>
        </div>
        <input ref={input} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={pick} data-testid={`${testid}-input`} />
      </div>
    </div>
  );
};
